import { Component } from '@angular/core';
import { NavigationCancel, ActivatedRoute, Router, Routes, RouterOutlet, RouterModule } from '@angular/router';
import { AppTitle } from './title';
import { Alert } from './alert';
import { Subscription } from 'rxjs';

@Component({
    selector: 'catchall',
    template:
    `<div class="col-lg-3 col-md-6 col-xs-12">
      <alert [alert]="msg"></alert>
   </div>`
})

export class CatchAllComponent {
    private subscription: Subscription;
    public msg: Alert;
    acctNumber: string;

    constructor(private router: Router, private title: AppTitle,  private activatedRoute: ActivatedRoute,) {
        this.msg = new Alert();

        this.subscription = activatedRoute.params.subscribe(
            (params) => this.acctNumber = params['acctNumber']
        )

        if (this.acctNumber == null) {
            this.msg.error(`Please go to your district manager.`);
        } else {
            title.setTitles({ title: 'Page not found', dashboard: 'Page not found', dashboardNav: '' });
            this.msg.error(`Page '${router.url}' could not be found, please use the menu for navigation or re-login.`);
        }
    }
}
